import moment from "moment";
import { ITicket } from "./TicketsManagement";
import { ConvertZ } from "../../../components/helpers/helperFunctions";

export interface ICalendarItem {
    id: number|string;
    flag: "dueDate" | "holiday" | "openDate" | "actionDate" | "task" ;
    title: string;
    start: any;
    end: any;
    scheduleDateTime:any;
    isDraggable: boolean;
    isDroppable: boolean;
    isSelectable: boolean;
    hexColor: string;
    pColor: string;
    description: string;
    isActive: boolean;
    group: string;
    agent: string;
    ticketLogs:any;
    ticketId?:number
};

export const ticketsToEvents = (tickets:ITicket[]) =>{
    const modifiedTickets:any[] = [];
    tickets.map((i:ITicket)=>{
        let {group,agent,ticketStatus,title,description,dueDateTime,slaRemaining,priority,firstResponseDueDateTime} = i?.ticketLogs;
        if(ticketStatus?.name === "Closed" || !dueDateTime) return;
        // if(dueDateTime){ dueDateTime = ConvertZ(dueDateTime)}
        // if(firstResponseDueDateTime) {firstResponseDueDateTime = ConvertZ(firstResponseDueDateTime)}
        const tempObj:ICalendarItem =  {
            id : i?.id || 0,
            flag : "dueDate",
            title : title || "",
            start: moment.utc(dueDateTime).toDate(),
            end: moment.utc(dueDateTime).add(10, "minutes").toDate(),
            scheduleDateTime: moment.utc(dueDateTime).toDate(),
            isDraggable: false,
            isDroppable: false,
            isSelectable: true,
            hexColor: slaRemaining && slaRemaining.includes("-") ? "#f2cdbb" : "#93e6bd",
            pColor: priority?.color || "#5558",
            description : description || "",
            isActive : true,
            group: group?.name || "-",
            agent: agent?.firstName ? `${agent.firstName} ${agent.lastName}` : "-" ,
            ticketLogs : i.ticketLogs
        }
        modifiedTickets.push(tempObj);

        if(firstResponseDueDateTime) {
            const tempObj2:ICalendarItem = {
                ...tempObj,
                flag:"actionDate",
                start: moment.utc(firstResponseDueDateTime).toDate(),
                end: moment.utc(firstResponseDueDateTime).add(10, "minutes").toDate(),
                scheduleDateTime: moment.utc(dueDateTime).toDate(),
            }
            modifiedTickets.push(tempObj2);
        }
    })
    console.log("ticketsToEvents_modifiedTickets",modifiedTickets)
    return modifiedTickets;
}
//ticketTaskList

export const tasksToEvents = (tickets:ITicket[]) =>{
    const modifiedTickets:any[] = [];
    tickets.map((i:ITicket)=>{
        let {group,ticketStatus,agent,title,description,dueDateTime,ticketId} = i?.ticketTaskLogs || {};
        // if(dueDateTime){ dueDateTime = ConvertZ(dueDateTime)}
//        if(ticketStatus?.name === "Closed") return;
        if(ticketStatus?.name === "Closed" || !dueDateTime) return;

        
        const tempObj:ICalendarItem =  {
            id : i?.id || 0,
            flag : "task",
            ticketId : i?.ticketId || ticketId || 0,
            title : title || "",
            start: moment.utc(dueDateTime).toDate(),
            end: moment.utc(dueDateTime).add(30, "minutes").toDate(),
            scheduleDateTime: moment.utc(dueDateTime).toDate(),
            // start: dueDateTime && moment(dueDateTime).subtract(30, "minutes").toDate(),
            // end: dueDateTime && new Date(dueDateTime),
            // scheduleDateTime:dueDateTime && new Date(dueDateTime),
            isDraggable: false,
            isDroppable: false,
            isSelectable: true,
            hexColor: "#eac3f3",
            pColor: "#a2019d",
            description : description || "",
            isActive : true,
            group: group?.name || "-",
            agent: agent?.firstName ? `${agent.firstName} ${agent.lastName}` : "-" ,
            ticketLogs : i?.ticketTaskLogs
        }
        modifiedTickets.push(tempObj);
    })
    console.log("ticketsToEvents_modifiedTickets",modifiedTickets)
    return modifiedTickets;
}



export interface IstoreTicketPopoverInfoProps{
    ticketId : number;
    anchorEl : any;
}


export interface IDashboardData {
        id : number,
        count : number
}
export interface ITicketStatusData {
    newTicketCount: number,
    openTicketCount: number,
    dataList: Record<string, IDashboardData>
}

export interface IDashboardInsights {
    ticketStatus: ITicketStatusData,
    priority: Record<string, IDashboardData>,
    tickettype: Record<string, IDashboardData>,
    dueToday: number,
    dueInWeek: number,  
    overdue: number,
    firstActionDateMeanTime : number,
    responseSlainPercentageToday: number,  
    resolutionSlainPercentageToday: number,  
    resolvedInSlaPercentage: number,
    resolvedToday: number,
    resolvedTodayPer:number,
}